import { render } from "./HospitalGlobalSettings.vue?vue&type=template&id=81c5d2be&scoped=true"
import script from "./HospitalGlobalSettings.vue?vue&type=script&lang=js"
export * from "./HospitalGlobalSettings.vue?vue&type=script&lang=js"

import "./HospitalGlobalSettings.vue?vue&type=style&index=0&id=81c5d2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c5d2be"]])

export default __exports__